import { use } from 'i18next';
import { initReactI18next } from 'react-i18next';

import auth from './en/auth.json';
import contacts from './en/contacts.json';

export const defaultNS = 'auth';

use(initReactI18next).init({
  lng: 'en', // if you're using a language detector, do not define the lng option
  debug: true,
  resources: {
    en: {
      auth,
      contacts,
    },
  },
  defaultNS,
});
